module.exports = __webpack_public_path__ + "static/media/wilson.6de7b101.png";